var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docs-wrap"},[_c('div',{ref:"host",staticClass:"docs-host"}),(_vm.error)?_c('p',{staticClass:"docs-error"},[_vm._v(" No pudimos cargar el detalle de Documentos PIE. Inicia sesión y prueba con tu próximo informe: los primeros son gratis. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }